import styled from 'styled-components';
const StyledProducts = styled.div`
  overflow-x: hidden;
  width: 100%;

 --background: oklch(0.97 0.006 145);
  --foreground: oklch(0.2 0.01 160);
  /* brand accents inspired by the reference: teal/green, yellow, pink */
  --optimal: oklch(0.72 0.15 165);
  --optimal-foreground: oklch(0.32 0.09 165);
  --optimal-muted: oklch(0.95 0.04 165);
  --caution: oklch(0.85 0.16 95);
  --alert: oklch(0.72 0.19 350);
  --alert-muted: oklch(0.96 0.03 350);
  --card: oklch(1 0 0);
  --card-foreground: oklch(0.2 0.01 160);
  --popover: oklch(1 0 0);
  --popover-foreground: oklch(0.145 0 0);
  --primary: oklch(0.205 0 0);
  --primary-foreground: oklch(0.985 0 0);
  --secondary: oklch(0.97 0 0);
  --secondary-foreground: oklch(0.205 0 0);
  --muted: oklch(0.96 0.005 160);
  --muted-foreground: oklch(0.58 0.01 160);
  --accent: oklch(0.97 0 0);
  --accent-foreground: oklch(0.205 0 0);
  --destructive: oklch(0.577 0.245 27.325);
  --border: oklch(0.91 0.006 160);
  --input: oklch(0.91 0.006 160);
  --ring: oklch(0.72 0.15 165);
  --chart-1: oklch(0.72 0.15 165);
  --chart-2: oklch(0.85 0.16 95);
  --chart-3: oklch(0.72 0.19 350);
  --chart-4: oklch(0.6 0.12 165);
  --chart-5: oklch(0.5 0.02 160);
  --radius: 1.25rem;
  --sidebar: oklch(0.985 0 0);
  --sidebar-foreground: oklch(0.145 0 0);
  --sidebar-primary: oklch(0.205 0 0);
  --sidebar-primary-foreground: oklch(0.985 0 0);
  --sidebar-accent: oklch(0.97 0 0);
  --sidebar-accent-foreground: oklch(0.205 0 0);
  --sidebar-border: oklch(0.922 0 0);
  --sidebar-ring: oklch(0.708 0 0);

  --color-optimal: var(--optimal);
  --color-optimal-foreground: var(--optimal-foreground);
  --color-optimal-muted: var(--optimal-muted);
  --color-caution: var(--caution);
  --color-alert: var(--alert);
  --color-alert-muted: var(--alert-muted);
  --color-sidebar-ring: var(--sidebar-ring);
  --color-sidebar-border: var(--sidebar-border);
  --color-sidebar-accent-foreground: var(--sidebar-accent-foreground);
  --color-sidebar-accent: var(--sidebar-accent);
  --color-sidebar-primary-foreground: var(--sidebar-primary-foreground);
  --color-sidebar-primary: var(--sidebar-primary);
  --color-sidebar-foreground: var(--sidebar-foreground);
  --color-sidebar: var(--sidebar);
  --color-chart-5: var(--chart-5);
  --color-chart-4: var(--chart-4);
  --color-chart-3: var(--chart-3);
  --color-chart-2: var(--chart-2);
  --color-chart-1: var(--chart-1);
  --color-ring: var(--ring);
  --color-input: var(--input);
  --color-border: var(--border);
  --color-destructive: var(--destructive);
  --color-accent-foreground: var(--accent-foreground);
  --color-accent: var(--accent);
  --color-muted-foreground: var(--muted-foreground);
  --color-muted: var(--muted);
  --color-secondary-foreground: var(--secondary-foreground);
  --color-secondary: var(--secondary);
  --color-primary-foreground: var(--primary-foreground);
  --color-primary: var(--primary);
  --color-popover-foreground: var(--popover-foreground);
  --color-popover: var(--popover);
  --color-card-foreground: var(--card-foreground);
  --color-card: var(--card);
  --color-foreground: var(--foreground);
  --color-background: var(--background);
  --radius-sm: calc(var(--radius) * 0.6);
  --radius-md: calc(var(--radius) * 0.8);
  --radius-lg: var(--radius);
  --radius-xl: calc(var(--radius) * 1.4);
  --radius-2xl: calc(var(--radius) * 1.8);
  --radius-3xl: calc(var(--radius) * 2.2);
  --radius-4xl: calc(var(--radius) * 2.6);
`;

export default StyledProducts;

